// Admin endpoints for the Research Pulse (core-lambda → aris-ai).
// Coverage Signals: recurring member needs no canonical Dialogue covers, clustered.
// Triage records a research decision only — it never creates, certifies or
// publishes a Dialogue. All routes require an admin token; core-lambda sets the
// triaging admin (`by`) itself.

import { axiosAssessmentInstance } from "../AxiosConfiguration";

const unwrap = (response, fallback = null) =>
  response?.data?.payload ?? fallback;

const BASE = "/api/admin/research-pulse";

const id = (value) => encodeURIComponent(String(value ?? ""));

/** Drops unset / "all" / blank values so core-lambda applies its defaults. */
const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value != null && value !== "" && value !== "all"
    )
  );

/**
 * @param {{status?: string, area?: string, since?: string, limit?: number}} params
 * @returns {Promise<{items: object[], count: number, statuses: string[]}>}
 */
export const listResearchPulseClusters = async (params = {}) => {
  const response = await axiosAssessmentInstance.get(`${BASE}/clusters`, {
    params: clean(params),
  });
  const payload = unwrap(response, {});
  const items = payload?.items || [];
  return {
    items,
    count: payload?.count ?? items.length,
    statuses: payload?.statuses || [],
  };
};

/** Row + `history[]` + `sample_signals[]`. */
export const getResearchPulseCluster = async (clusterId) => {
  const response = await axiosAssessmentInstance.get(
    `${BASE}/clusters/${id(clusterId)}`
  );
  return unwrap(response);
};

/**
 * Triage a cluster. `status` is required; the optional keys are sent only when set.
 *
 * @param {string} clusterId
 * @param {{status: string, note?: string, linked_dialogue_id?: string,
 *   trace_stage?: string, trace_ref?: string}} triage
 */
export const triageResearchPulseCluster = async (
  clusterId,
  { status, note, linked_dialogue_id, trace_stage, trace_ref } = {}
) => {
  const body = { status };
  const optional = { note, linked_dialogue_id, trace_stage, trace_ref };
  Object.entries(optional).forEach(([key, value]) => {
    const trimmed = typeof value === "string" ? value.trim() : value;
    if (trimmed != null && trimmed !== "") body[key] = trimmed;
  });
  const response = await axiosAssessmentInstance.patch(
    `${BASE}/clusters/${id(clusterId)}`,
    body
  );
  return unwrap(response);
};

/** @param {{since?: string}} [params] since omitted = the last 7 days. */
export const getResearchPulseDigest = async (params = {}) => {
  const response = await axiosAssessmentInstance.get(`${BASE}/digest`, {
    params: clean(params),
  });
  return unwrap(response, {});
};
